import React from 'react';
import styles from './index.css';
import Slides from '../slides';
import { h5PageCount } from '../../../utils';
import { WxLaunchApp } from '../../wxLaunchApp';
const { callApp, getSchemeLink } = require('@ifeng/callapp');
// import { QQShare } from '../../qqShare';
const dotTmpl = (current, total) => {
    const dots = [];
    for (let i = 0; i < total; i++) {
        dots.push(React.createElement("span", { key: i, className: current === i ? styles.current : styles.dot }));
    }
    return (React.createElement("div", { className: styles.dots_box },
        React.createElement("div", { className: styles.dots }, dots)));
};
class BottomSlides extends React.PureComponent {
    constructor(props) {
        super(props);
        this.currentIndex = 0;
        this.isOnceLoad = true;
        this.handleClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
            const { content, isVideoShare } = this.props;
            const item = content[this.currentIndex] || {};
            // const docType = item.newstype || 'bottomNav';
            const docType = item.newstype || 'awake';
            const aid = item._id || item.id;
            const clickCountConfig = item.clickCount || {};
            const kind = item.kind || content[0].kind || '';
            const noPrefixKind = item.noPrefixKind || '';
            const client = isVideoShare ? 'videoApp' : 'newsApp';
            const downloads = item.downloads || content[0].downloads || { download: '', downloadAd: '' };
            // const phoenixConfig = docType === 'bottomNav' ? { navId: 'bottomNavVideo', pid: 'vch_phoenix'} : {};
            if (item.channel !== 'treasure') {
                if (isSendCount && clickCountConfig.type) {
                    this.feedClickCountFn(clickCountConfig);
                }
                if (isJumpQQlink && clickCountConfig.other) {
                    clickCountConfig.other.tag = 't9';
                    this.feedClickCountFn(clickCountConfig);
                }
                if (isCallApp) {
                    callApp({
                        client,
                        docType,
                        pid: aid,
                        kind,
                        download: downloads.download,
                        downloadAd: downloads.downloadAd,
                        noKindFrom: noPrefixKind,
                        isCopySchemeUrl: isJumpQQlink,
                    });
                }
            }
            else {
                this.handleCallTreasure(item);
            }
        };
        this.handleCallTreasure = (item) => {
            const shareUrl = item.share || '';
            const dlUrl = item.dlUrl || '';
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'to_tmall',
                },
            ]);
            this.taobaoExp(this.state.tbClickUlr);
            setTimeout(() => {
                location.href = dlUrl;
            }, 50);
            setTimeout(() => {
                location.href = shareUrl;
            }, 2000);
        };
        this.closeSlideFn = () => {
            const { content } = this.props;
            const countConfig = content[1] && content[1].clickCount;
            if (countConfig) {
                h5PageCount([
                    {
                        behavior: countConfig.behavior,
                        type: 'downopenx',
                        other: {
                            ref: (countConfig.other && countConfig.other.ref) || '',
                            to: 'newsapp',
                            kind: 'article',
                            url: (countConfig.other && countConfig.other.url) || '',
                            plat: 'napp',
                            downurl: (countConfig.other && countConfig.other.downurl) || '',
                        },
                    },
                ]);
            }
            this.setState({
                isHasSlide: false,
            });
        };
        this.feedClickCountFn = (config) => {
            if (!config) {
                config = {
                    behavior: 'action',
                    type: 'downopen',
                    other: {
                        ref: encodeURIComponent(document.referrer),
                        kind: 'article',
                        url: encodeURIComponent(location.href),
                    },
                };
            }
            h5PageCount([config]);
        };
        this.afterSlide = (currentIndex, total) => {
            this.currentIndex = currentIndex;
            const liveSlideData = this.allContentData[this.currentIndex];
            this.setState({
                liveSlideData
            });
        };
        this.afterAutoplay = (currentIndex, total) => {
            this.taobaoExp(this.state.tbExpUrl);
            this.currentIndex = currentIndex;
            const liveSlideData = this.allContentData[this.currentIndex];
            this.setState({
                liveSlideData
            });
        };
        this.taobaoExp = (url) => {
            const { content } = this.props;
            const item = content[this.currentIndex];
            if (item && item.channel === 'treasure') {
                const imgDom = document.createElement('img');
                imgDom.style.display = 'none';
                imgDom.src = url;
                document.body.appendChild(imgDom);
            }
        };
        this.sliderTmpl = (item) => {
            const { isVideoShare } = this.props;
            // const schemeConfig = item.newstype ? 
            //                         {
            //                             docType: item.newstype || 'awake',
            //                             pid: item._id || item.id || '',
            //                             kind: item.kind || 'share01',
            //                             noPrefixKind: item.noPrefixKind || ''
            //                         }:
            //                         {
            //                             docType: 'bottomNav',
            //                             pid: 'vch_phoenix',
            //                             navId: 'bottomNavVideo',
            //                             kind: item.kind || 'share01',
            //                             noPrefixKind: item.noPrefixKind || ''
            //                         }
            // let schemeLink = getSchemeLink(schemeConfig);
            let schemeLink = getSchemeLink({
                docType: item.newstype || 'awake',
                pid: item._id || item.id || '',
                kind: item.kind || 'share01',
                noPrefixKind: item.noPrefixKind || ''
            });
            if (item.wxLaunchType === 'weapp') {
                schemeLink = `pages/new/new.html?aid=ucms_${item.id}&types=doc&showtype=titleimg&ref=sy&from=wxh5`;
            }
            if (item.type === 'aid') {
                return (React.createElement("div", { className: styles.swiper },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick },
                        React.createElement("span", { className: styles.img_box },
                            isVideoShare && React.createElement("span", { className: styles.videoLogo }),
                            !isVideoShare && React.createElement("span", { className: styles.logo })),
                        !isVideoShare && item.wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, 
                            // schemeLink={schemeLink}
                            launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) }))));
            }
            else if (item.type === 'web') {
                return (React.createElement("div", { className: styles.swiper },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick },
                        React.createElement("img", { className: styles.webPic, src: item.thumbnailpic }),
                        !isVideoShare && item.wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) }))));
            }
            else {
                return (React.createElement("div", { className: styles.swiper },
                    React.createElement("div", { className: styles.swiper_item, onClick: this.handleClick },
                        React.createElement("span", { className: styles.img_box }, item.thumbnailpic && React.createElement("img", { src: item.thumbnailpic, className: styles.pic })),
                        React.createElement("span", { className: styles.title },
                            React.createElement("span", { className: styles.titleBox }, item.title)),
                        !isVideoShare && item.wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: item.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) }))));
            }
        };
        this.isAddLogoPic = false;
        this.aid = {
            type: 'aid',
            wxLaunchType: this.props.content && this.props.content[0] && this.props.content[0].wxLaunchType,
            wxLaunchSwitch: this.props.content && this.props.content[0] && this.props.content[0].wxLaunchSwitch,
        };
        this.allContentData = this.props.content;
        this.handleContent = (content, indexArr) => {
            this.allContentData = content;
            if (!indexArr || this.isAddLogoPic)
                return content;
            for (const index of indexArr) {
                content.splice(index, 0, this.aid);
            }
            this.isAddLogoPic = true;
            this.allContentData = content;
            return content;
        };
        this.state = {
            isHasSlide: true,
            liveSlideData: (this.props.content && this.props.content[0]) || {},
            tbExpUrl: 'https://ef-dongfeng.tanx.com/nim?e=lx4Y7A3_nZd5PDnPARRLae3JIevFpEOkl_KY_7WeQ2x6PewBERzQx0-wQ6Rp9v30a81ennGjQpfV4m9hs_FgQ-OtOnnqSEbsXCmuVdd8Eu4&k=106&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
            tbClickUlr: 'https://ef-dongfeng.tanx.com/ncm?e=lx4Y7A3_nZd5PDnPARRLae3JIevFpEOkl_KY_7WeQ2x6PewBERzQx0-wQ6Rp9v30a81ennGjQpfV4m9hs_FgQ-OtOnnqSEbsXCmuVdd8Eu4&k=106&ext=a%3d__IMEI__%26b%3d__IDFA__%26c%3d__MAC__%26d%3d__OAID__',
        };
    }
    componentDidMount() {
        this.isOnceLoad = false;
        this.taobaoExp(this.state.tbExpUrl);
    }
    render() {
        let { content, aidIndex, noCloseIcon = false, maxWidth = '1024px', isVideoShare } = this.props;
        content = content.filter(item => {
            return item.newstype !== 'nodata';
        });
        const { isHasSlide, liveSlideData } = this.state;
        const config = {
            sliderTmpl: this.sliderTmpl,
            dotTmpl,
            autoplay: !(content.length === 0),
            dots: !(content.length === 0),
            afterSlide: this.afterSlide,
            afterAutoplay: this.afterAutoplay,
        };
        const noCloseIconName = noCloseIcon ? styles.noCloseIcon : '';
        // const schemeConfig = liveSlideData.newstype ? 
        //                         {
        //                             docType: liveSlideData.newstype || 'awake',
        //                             pid: liveSlideData._id || liveSlideData.id || '',
        //                             kind: liveSlideData.kind || 'share01',
        //                             noPrefixKind: liveSlideData.noPrefixKind || ''
        //                         }:
        //                         {
        //                             docType: 'bottomNav',
        //                             pid: 'vch_phoenix',
        //                             navId: 'bottomNavVideo',
        //                             kind: liveSlideData.kind || 'share01',
        //                             noPrefixKind: liveSlideData.noPrefixKind || ''
        //                         };
        // let schemeLink = getSchemeLink(schemeConfig);
        let schemeLink = getSchemeLink({
            docType: liveSlideData.newstype || 'awake',
            pid: liveSlideData._id || liveSlideData.id || '',
            kind: liveSlideData.kind || 'share01',
            noPrefixKind: liveSlideData.noPrefixKind || ''
        });
        if (liveSlideData.wxLaunchType === 'weapp') {
            schemeLink = `pages/new/new.html?aid=ucms_${liveSlideData.id}&types=doc&showtype=titleimg&ref=sy&from=wxh5`;
            if (!liveSlideData.id) {
                schemeLink = '';
            }
        }
        if (!this.isOnceLoad) {
            content = this.allContentData;
        }
        return (isHasSlide && (React.createElement("div", { className: styles.box, style: { maxWidth } },
            React.createElement("div", { className: styles.silde_box },
                React.createElement(Slides, { content: this.handleContent(content, aidIndex), config: config })),
            React.createElement("div", { className: `${styles.opt} ${noCloseIconName}`, onClick: this.handleClick },
                React.createElement("span", { className: styles.btn }, "\u6253\u5F00"),
                React.createElement("span", { className: styles.close }),
                !isVideoShare && liveSlideData.wxLaunchSwitch && React.createElement(WxLaunchApp, { launchType: liveSlideData.wxLaunchType, schemeLink: schemeLink, launchAppClick: this.handleClick.bind(this, true, false, false), launchAppFail: this.handleClick.bind(this, false, true, true) })))));
    }
}
export default BottomSlides;
